import { render, staticRenderFns } from "./SistemasIntegradosPublico.vue?vue&type=template&id=7438c747&scoped=true&"
import script from "./SistemasIntegradosPublico.vue?vue&type=script&lang=js&"
export * from "./SistemasIntegradosPublico.vue?vue&type=script&lang=js&"
import style0 from "./SistemasIntegradosPublico.vue?vue&type=style&index=0&id=7438c747&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7438c747",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VChip,VCol,VContainer,VIcon,VImg,VRow})
